<template>
  <b-field
    :label="label"
    label-position="on-border"
    class="country-selector"
  >
    <b-dropdown v-if="countries" :mobile-modal="false" v-model="selectedCountryId" @input="$emit('input', selectedCountryId)" expanded>
      <template v-if="selectedCountry" #trigger="{ active }">
        <button class="button input" @click.prevent>
          <div class="button-content">
            <span v-html="getFlag(selectedCountry.flag)" class="flag"></span>
            <span>{{ selectedCountry.languageName }}</span>
          </div>
          <b-icon icon-pack="fa" :icon="active ? 'chevron-up' : 'chevron-down'" size="is-small"></b-icon>
        </button>
      </template>

      <template v-else #trigger="{ active }">
        <button class="button input" @click.prevent>
          <div class="button-content">
            <span>{{ $t("mp.country_select.placeholder") }}</span>
          </div>
          <b-icon icon-pack="fa" :icon="active ? 'chevron-up' : 'chevron-down'" size="is-small"></b-icon>
        </button>
      </template>

      <b-dropdown-item v-for="country in countries" :key="country.id" :value="country.id">
        <div class="country-list-item">
          <div v-html="getFlag(country.flag)" class="flag"></div>
          <div>{{ country.languageName }} ({{ country.languageNameEnglish }})</div>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </b-field>
</template>

<script>
import { mapGetters } from "vuex/dist/vuex.common.js";
import twemoji from "@twemoji/api";

export default {
  name: "CountrySelect",
  props: ['value', 'label'],
  data() {
    return {
      selectedCountryId: this.value,
    };
  },
  computed: {
    ...mapGetters({
      countries: "i18n/countries",
    }),
    selectedCountry() {
      return this.countries.find(country => country.id === this.selectedCountryId);
    },
  },
  methods: {
    getFlag(flag) {
      if (flag) {
        return twemoji.parse(flag, {
          folder: "svg",
          ext: ".svg",
        });
      }
    },
  },
  watch: {
    value: {
      handler(value) {
        this.selectedCountryId = value;
      },
      once: true
    }
  },
};
</script>

<style scoped lang="scss">
.country-selector {
  margin-bottom: 2rem;

  button.button.input {
    display: flex;
    align-items: center;
    justify-content: space-between;

    div.button-content {
      display: flex;
      align-items: center;
      gap: 8px;

      .flag {
        width: 24px;
        height: 24px;
      }
    }
  }
}

.country-list-item {
  display: flex;
  align-items: center;
  gap: 8px;

  .flag {
    width: 24px;
    height: 24px;
  }
}
</style>